import { render, staticRenderFns } from "./Demo3d.vue?vue&type=template&id=ab306a8c&scoped=true&"
import script from "./Demo3d.vue?vue&type=script&lang=js&"
export * from "./Demo3d.vue?vue&type=script&lang=js&"
import style0 from "./Demo3d.vue?vue&type=style&index=0&id=ab306a8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab306a8c",
  null
  
)

export default component.exports